import { EmptyState, Icon, SectionCard } from "@iec-id/ui";
import { createRootRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/shell/app-shell";

export const Route = createRootRoute({
	component: AppShell,
	notFoundComponent: SectionNotFound,
});

/**
 * Неизвестный путь витрины. Показывается внутри оболочки, а не вместо неё:
 * человек не должен терять шапку и меню из-за опечатки в адресе.
 */
function SectionNotFound() {
	const { t } = useTranslation("common");
	return (
		<SectionCard>
			<EmptyState
				icon={<Icon name="CircleAlert" size={32} />}
				title={t("state.errorTitle")}
				description={t("state.errorDescription")}
			/>
		</SectionCard>
	);
}
